import {
    Euro,
    CalendarDays,
    Gift,
    Bike,
    Layers,
    Users,
    Zap,
    ShieldCheck,
    Heart,
    Wrench,
    GraduationCap,
    Coffee,
    Sun,
    Truck,
    Award,
    Clock,
    Handshake,
    Leaf,
    Star,
    Smile,
    Beaker,
    Gauge,
    Cpu,
    LineChart,
    Droplets,
    Recycle,
} from "lucide-react";

export const BENEFIT_ICONS = {
    euro: { icon: Euro, label: "Euro / Geld" },
    calendar: { icon: CalendarDays, label: "Kalender / Urlaub" },
    gift: { icon: Gift, label: "Geschenk" },
    bike: { icon: Bike, label: "Fahrrad" },
    layers: { icon: Layers, label: "Vielfalt" },
    users: { icon: Users, label: "Team" },
    zap: { icon: Zap, label: "Blitz / Technik" },
    shield: { icon: ShieldCheck, label: "Sicherheit" },
    heart: { icon: Heart, label: "Herz" },
    wrench: { icon: Wrench, label: "Werkzeug" },
    graduation: { icon: GraduationCap, label: "Weiterbildung" },
    coffee: { icon: Coffee, label: "Kaffee / Pause" },
    sun: { icon: Sun, label: "Sonne" },
    truck: { icon: Truck, label: "Fahrzeug" },
    award: { icon: Award, label: "Auszeichnung" },
    clock: { icon: Clock, label: "Arbeitszeit" },
    handshake: { icon: Handshake, label: "Handschlag" },
    leaf: { icon: Leaf, label: "Umwelt" },
    star: { icon: Star, label: "Stern" },
    smile: { icon: Smile, label: "Lächeln" },
    beaker: { icon: Beaker, label: "Labor / Chemie" },
    gauge: { icon: Gauge, label: "Messgerät" },
    cpu: { icon: Cpu, label: "Steuerung / Technik" },
    chart: { icon: LineChart, label: "Diagramm / Daten" },
    droplets: { icon: Droplets, label: "Wasser" },
    recycle: { icon: Recycle, label: "Recycling" },
};

export const getBenefitIcon = (name) => (BENEFIT_ICONS[name] || BENEFIT_ICONS.star).icon;
